import { render, staticRenderFns } from "./boardSchedule.vue?vue&type=template&id=362207d7&scoped=true"
import script from "./boardSchedule.vue?vue&type=script&lang=js"
export * from "./boardSchedule.vue?vue&type=script&lang=js"
import style0 from "./boardSchedule.vue?vue&type=style&index=0&id=362207d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362207d7",
  null
  
)

export default component.exports